// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:479px){.mobileOnly[data-v-65cefb4c]{display:unset}.desktopOnly[data-v-65cefb4c]{display:none}}", ""]);
// Exports
module.exports = exports;
